<template>
  <div class="map-container">
    <el-input v-if="isSearch" v-model="searchAddressForm.name" placeholder="搜索地址" class="input-with-select" @change="changeAddress" @keydown.enter="searchAddressList">
      <template #append>
        <el-button :icon="Search" @click="searchAddressList" />
      </template>
    </el-input>
    <el-scrollbar v-if="isSearch && showScroll" style="width: 100%; padding: 15px 0" height="240px" @end-reached="loadMore">
      <p style="width: 100%" v-for="(address, index) in addressList" :key="index" class="scrollbar-demo-item" @click="selectAddress(address)">
        {{ address.name }}
      </p>
    </el-scrollbar>
    <div id="amapContainer"></div>
  </div>
</template>

<script>
import AMap from "@amap/amap-jsapi-loader"
import { Search } from "@element-plus/icons-vue"
import { shallowRef } from "vue"
import coordtransform from "coordtransform"
export default {
  props: {
    longitude: {
      type: [String, Number],
      default: null
    },
    latitude: {
      type: [String, Number],
      default: null
    },
    addressName: {
      type: String,
      default: null
    },
    mode: {
      type: String, //"edit" | "view"
      default: "edit"
    }
  },

  emits: ["selectAddress"],
  data() {
    return {
      Search: shallowRef(Search),
      addressList: [],
      addressInfo: {},
      AMap: null,
      map: null,
      marker: null,
      currentPositionMarker: null,
      searchAddressForm: {
        page: 1,
        lon: this.longitude,
        lat: this.latitude,
        name: "",
        offset: 10
      },
      currentPosition: [],
      showScroll: false
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    longitude: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  computed: {
    isSearch() {
      // console.log("this.mode", this.mode)
      return this.mode == "edit"
    }
  },
  methods: {
    init() {
      // console.log("传来的数据", this.latitude, this.longitude)
      this.initMap()
      if (this.addressName) {
        this.searchAddressForm.name = this.addressName
      }
    },
    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "e826bd4b84402f209227834e93125aaf	" // 安全密钥
      }
      // AMap => 加载器
      // 资源加载完成后就会触发 then
      AMap.load({
        key: "b4a6d033766fab66505ae0f343d4f4c7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
        plugins: [] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          // console.log("初始化", self.longitude, self.latitude)
          this.AMap = AMap
          // 初始化地图
          this.map = new AMap.Map("amapContainer", {
            viewMode: "2D", // 是否为3D地图模式
            zoom: 15, // 初始化地图级别
            center: [this.longitude, this.latitude], //中心点坐标
            resizeEnable: true
          })
          const gcj02 = coordtransform.wgs84togcj02(this.longitude, this.latitude)
          const longitude = gcj02[0]
          const latitude = gcj02[1]
          if (this.isSearch) {
            this.initMarker(longitude, latitude, "当前位置")
          } else {
            this.initMarker(longitude, latitude, "认领位置")
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    initMarker(longitude, latitude, title) {
      // console.log("initMarker", longitude, latitude, title)
      const position = new this.AMap.LngLat(longitude, latitude)
      //点标记显示内容
      const markerContent = `<div class="custom-content-marker">
<img src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png">
<div class="content-text" onclick="clearMarker()">${title} <text class="select">${this.addressName || ""}</text>
  </div>
</div>`
      this.currentPositionMarke = new this.AMap.Marker({
        position: position,
        content: markerContent, //将 html 传给 content
        offset: new this.AMap.Pixel(-13, -30) //以 icon 的 [center bottom] 为原点
      })
      this.map.add(this.currentPositionMarke)
    },
    changeAddress() {
      this.addressList = []
    },
    searchAddressList() {
      const req = {
        keyword: this.searchAddressForm.name,
        lon: this.longitude,
        lat: this.latitude,
        page: this.searchAddressForm.page
      }
      this.$API.special.address.searchNearbyPois(req).then((res) => {
        if (res.success) {
          if (res.data.length > 0) {
            this.addressList = [...this.addressList, ...res.data]
            this.showScroll = true
          } else {
            this.showScroll = false
            this.$message.warning("未找到相关地址")
          }
        }
      })
    },
    selectAddress(address) {
      // 检查 AMap 是否已加载
      if (!this.AMap) {
        console.error("AMap 未初始化")
        return
      }
      if (this.marker) {
        this.map.remove(this.marker)
      }
      this.searchAddressForm.name = address.name
      this.addressInfo = address
      this.showScroll = false
      const selectPosition = address.location.split(",")
      const position = new this.AMap.LngLat(...selectPosition)
      const markerContent = `<div class="custom-content-marker">
<img src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png">
<div class="content-text" onclick="clearMarker()">认领地址：<text class="select">${address.name}</text>
 </div>
</div>`
      this.marker = new this.AMap.Marker({
        position: position,
        content: markerContent, //将 html 传给 content
        offset: new this.AMap.Pixel(-13, -30) //以 icon 的 [center bottom] 为原点
      })
      this.map.add(this.marker)
      this.map.setCenter(position)
      this.map.setZoom(14)
      this.$emit("selectAddress", address)
    },
    loadMore(e) {
      if (e == "bottom") {
        if (this.addressList.length == this.searchAddressForm.offset * this.searchAddressForm.page) {
          this.searchAddressForm.page += 1
          this.searchAddressList()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  #amapContainer {
    overflow: hidden;
    width: 100%;
    height: 300px;
    margin: 15px 0 13px;
    ::v-deep .custom-content-marker {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100px;
      height: 100px;
      img {
        width: 25px;
        height: 34px;
      }
      .content-text {
        width: 100%;
        font-size: 14px;
        padding: 15px;
        color: #409eff;
        background: rgba(255, 255, 255, 1);
        // color: #000;
        // background: rgba(255, 255, 255, 0.6);
        border-radius: 12px;
        text-align: center;
        line-height: 15px;
        box-shadow: -1px 1px 1px rgba(10, 10, 10, 0.2);
        &:hover {
          background: #ebf5ff;
        }
        .select {
          color: red;
        }
      }
    }
  }
}
</style>
